import React from 'react';
import { createMemoryRouter, RouterProvider } from 'react-router-dom';

import About from './components/About.jsx';
import Achievements from './components/Achievements.jsx';
import AvatarPicker from './components/Avatar/AvatarPicker.jsx';
import ComputerMenu from './components/ComputerMenu.jsx';
import Game from './components/Game.jsx';
import HowToPlay from './components/HowToPlay.jsx';
import Loading from './components/Loading.jsx';
import MainMenu from './components/MainMenu.jsx';
import MoreGames from './components/MoreGames.jsx';
import OnlineMenu from './components/OnlineMenu.jsx';
import OnlineWaitingRoom from './components/OnlineWaitingRoom.jsx';
import Profile from './components/Profile.jsx';
import Root from './components/Root.jsx';
import Settings from './components/Settings.jsx';
import Statistics from './components/Statistics.jsx';
import Store from './components/Store.jsx';
import Test from './components/Test.jsx';
import { AppContextProvider } from './AppContext';

const router = createMemoryRouter([
	{
		path: '/',
		element: <Root />,
		children: [
			{
				index: true,
				path: '/',
				element: <MainMenu />,
			},
			{
				path: '/MainMenu',
				element: <MainMenu />,
			},
			{
				path: 'ComputerMenu',
				element: <ComputerMenu />,
			},
			{
				path: 'About',
				element: <About />,
			},
			{
				path: 'Achievements',
				element: <Achievements />,
			},
			{
				path: 'Game/:mode/:level',
				element: <Game />,
			},
			{
				path: 'Statistics',
				element: <Statistics />,
			},
			{
				path: 'HowToPlay',
				element: <HowToPlay />,
			},
			{
				path: 'Settings',
				element: <Settings />,
			},
			{
				path: 'Loading',
				element: <Loading />,
			},
			{
				path: 'MoreGames',
				element: <MoreGames />,
			},
			{
				path: 'Test',
				element: <Test />,
			},
			{
				path: 'Store',
				element: <Store />,
			},
			{
				path: 'Profile',
				element: <Profile />,
			},
			{
				path: 'Avatar',
				element: <AvatarPicker />,
			},
			{
				path: 'Online',
				element: <OnlineMenu />,
			},
			{
				path: 'Online/:mode',
				element: <OnlineWaitingRoom />,
			},
		],
	},
]);


const App = () => {

	if (import.meta.hot) {
		import.meta.hot.dispose(() => router.dispose());
	}

	return (
		<AppContextProvider router={router}>
			<RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
		</AppContextProvider>
	);
};

export default App;
